const PDFJS_VERSION = '5.4.530';
const CDN_BASE = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${PDFJS_VERSION}`;

// Array.prototype.at (Chrome 92, Safari 15.4, Firefox 90) implies the private class
// fields and ?? that the modern build needs. Probing syntax with new Function() is
// avoided on purpose: a Content-Security-Policy without unsafe-eval makes it throw,
// which sent every browser down the legacy path.
const supportsModernJS = () => typeof Array.prototype.at === 'function';

const loadScriptTag = (url, type) => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        if (type) {
            script.type = type;
        }
        script.src = url;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
        document.head.appendChild(script);
    });
};

let pdfjsLib = null;
let isInitialized = false;
const useLegacy = !supportsModernJS();

export const initPdfJs = async () => {
    if (isInitialized) {
        return pdfjsLib;
    }

    try {
        if (useLegacy) {
            // const scriptUrl = `${CDN_BASE}/legacy/build/pdf.min.js`;
            // const workerUrl = `${CDN_BASE}/legacy/build/pdf.worker.min.js`;
            const scriptUrl = `/legacy.pdf.min.js`;
            const workerUrl = `/legacy.pdf.worker.min.js`;

            // The legacy build is an ES module (export + import.meta) that also sets
            // globalThis.pdfjsLib; as a classic script it fails to parse and defines nothing.
            await loadScriptTag(scriptUrl, 'module');

            if (!window.pdfjsLib) {
                throw new Error('PDF.js library not found on window object after loading');
            }

            pdfjsLib = window.pdfjsLib;
            pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;
        } else {
            // const scriptUrl = `${CDN_BASE}/build/pdf.min.mjs`;
            // const workerUrl = `${CDN_BASE}/build/pdf.worker.min.mjs`;
            const scriptUrl = `/pdf.min.js`;
            const workerUrl = `/pdf.worker.min.js`;

            pdfjsLib = await import(/* @vite-ignore */ scriptUrl);
            pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;
        }

        isInitialized = true;
        return pdfjsLib;
    } catch (error) {
        console.error('Failed to initialize PDF.js:', error);
        throw error;
    }
};

export const getPdfJs = () => {
    if (!isInitialized) {
        throw new Error('PDF.js not initialized. Call initPdfJs() first.');
    }
    return pdfjsLib;
};

export const isLegacyMode = () => useLegacy;
